import { Box, Button, Fade, Modal} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
interface Props {
    open: boolean
    setOpen: (open: boolean) => void
}



export default function ModalTermoCondicao({ open, setOpen }: Props) {
    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}

        >
            <Fade in={open}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', md: 1000 },
                    height: 600,
                    overflow: 'auto',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    backgroundColor: '#F2EFE9',
                    borderEndStartRadius: 10,
                    borderStartStartRadius: 10,
                    borderStartEndRadius: 10,
                    borderEndEndRadius: 10,
                    p: { xs: 2, md: 4 },
                }}>
                    <p className="md:text-[38px] text-2xl font-bold text-center mt-6">
                        Termos e Condições de Uso
                    </p>
                    <div className="flex justify-end fixed top-6 right-0 h-0">
                        <Button>
                            <CloseIcon className="text-black"  onClick={() => setOpen(false)} />
                        </Button>
                    </div>
                    <section className="mb-6 mt-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">1. Introdução</h2>
                        <p className="md:text-base text-sm">
                            Bem-vindo ao site Forbli (forbli.com.br). Estes Termos e Condições regulam o uso do nosso site. Ao acessá-lo, você concorda com os termos aqui descritos. Caso não concorde, pedimos que interrompa o uso do site.
                        </p>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">2. Uso do Site</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                O conteúdo do site é destinado a informações gerais sobre os serviços oferecidos pela Forbli.
                            </li>
                            <li className="md:text-base text-sm">
                                Você se compromete a utilizar o site para fins legais e respeitar as normas aplicáveis.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">3. Propriedade Intelectual</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                Todos os textos, imagens, gráficos e demais conteúdos são protegidos por direitos autorais e pertencem à Forbli.
                            </li>
                            <li className="md:text-base text-sm">
                                É proibido reproduzir, distribuir ou modificar qualquer conteúdo sem autorização prévia.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">4. Limitação de Responsabilidade</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                A Forbli não se responsabiliza por danos diretos ou indiretos causados pelo uso do site.
                            </li>
                            <li className="md:text-base text-sm">
                                O site pode conter links para terceiros, mas a Forbli não se responsabiliza pelo conteúdo ou práticas desses sites.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">5. Privacidade</h2>
                        <p className="md:text-base text-sm">O uso do site está sujeito à nossa Política de Privacidade, que explica como coletamos e utilizamos suas informações.</p>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">6. Modificações nos Termos</h2>
                        <p className="md:text-base text-sm">Reservamo-nos o direito de alterar estes Termos e Condições a qualquer momento. Recomendamos que os usuários revisitem esta página regularmente para se manterem informados.</p>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">7. Legislação Aplicável</h2>
                        <p className="md:text-base text-sm">Estes Termos e Condições estão sujeitos às leis brasileiras. Qualquer disputa será resolvida no foro da cidade onde a Forbli está estabelecida.</p>
                    </section>

                    <section>
                        <h2 className="md:text-xl text-base font-semibold mb-2">8. Contato</h2>
                        <p className="md:text-base text-sm">
                            Para dúvidas ou esclarecimentos sobre os Termos e Condições, entre em contato pelo e-mail
                            forbli.contato@gmail.com
                        </p>
                    </section>
                </Box>
            </Fade>
        </Modal>
    )
}